<template>
  <div class="form-group" :class="{ 'has-error': errors.has(validationKey) }">
  <label :for="name"><span v-if="isRequired">*</span> {{ label }}</label>

  <select :id="name"
          class="form-control"
          :value="value"
          :placeholder="label"
          :name="name"
          :data-vv-as="label"
          v-validate="validators"
          v-bind="$attrs"
          v-on:change="$emit('input', $event.target.value)"
  >
    <option v-for="option in options"
            :key="option.id"
            :value="option.id"
    >
      {{ option.label }}
    </option>
  </select>
  <span v-show="errors.has(validationKey)" class="help-block ">{{ errors.first(validationKey) }}</span>
</div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: false,
    },
    validationScope: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    validators: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    isRequired() {
      if (this.validators) {
        if (typeof this.validators === 'string') {
          return this.validators.includes('required');
        } else if (this.validators.required) {
          return true;
        }
      }
    },
    validationKey() {
      if (this.validationScope) {
        return `${this.validationScope}.${this.name}`;
      } else {
        return this.name;
      }
    },
  },
  inject: {
    $validator: '$validator'
  },
}
</script>



// WEBPACK FOOTER //
// FormSelect.vue?b610a746